import React, { Component } from 'react';
class Video extends Component {
  constructor() {
    super();
    this.state = { 
    };
  } 

componentDidMount(){ 

}

 
  

  render() {
    return (
        <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container inner_con">
                <h1 className="text-center mb-5">Video</h1>
                <div className="owl-carousel video-carousel">
                    <div className="video-item bg-light rounded p-4">
                        <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDchsz8nmbo?si=1dbWOzUPaimMWGQ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <p className="mt-2"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></p>
                    </div>
                    <div className="video-item bg-light rounded p-4">
                       <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDchsz8nmbo?si=1dbWOzUPaimMWGQ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <p className="mt-2"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></p>
                    </div>
                    <div className="video-item bg-light rounded p-4">
                        <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDchsz8nmbo?si=1dbWOzUPaimMWGQ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <p className="mt-2"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></p>
                    </div>
                    <div className="video-item bg-light rounded p-4">
                        <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDchsz8nmbo?si=1dbWOzUPaimMWGQ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <p className="mt-2"><b>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</b></p>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Video;
